import { Outlet } from "react-router-dom";
import { QrCode, Briefcase, UserCircle } from "lucide-react";
import { HubShell } from "@/components/layout/HubTabs";

const TABS = [
  { key: "my-card", label: "My Card", to: "/portal/account/card", icon: QrCode },
  { key: "my-business", label: "My Business", to: "/portal/account/business", icon: Briefcase },
  { key: "profile-privacy", label: "Profile & Privacy", to: "/portal/account/profile", icon: UserCircle },
];

export default function AccountHub() {
  return (
    <HubShell
      eyebrow="My Account"
      description="Your member card, business details, and privacy settings — all in one place."
      testIdPrefix="account"
      tabs={TABS}
    >
      <Outlet />
    </HubShell>
  );
}
